import React, { Component } from "react";
import { motion } from "framer-motion";
import styled, { css } from "styled-components";

import { primary } from "@formant/ui/component/common/Colors";
import { Icon, IconName } from "@formant/ui/component/common/Icon";
import { Typography } from "@formant/ui/component/common/Typography";

import { Button, ButtonProps } from "../common/Button";
import { CircleButton } from "../common/CircleButton";

export interface IListButtonProps extends ButtonProps {
    icon?: IconName;
    kebab?: boolean;
    empty?: boolean;
    className?: string;
}

class ListButtonComponent extends Component<IListButtonProps> {
    public render() {
        const { className, children } = this.props;
        const { empty, kebab, icon, ...buttonProps } = { ...this.props };
        return (
            <motion.div whileHover="hover">
                <StyledButton className={className} {...buttonProps}>
                    {kebab && <Kebab size="18" icon="kebab" />}
                    <StyledTypography
                        color={empty ? primary.silver : primary.white}
                        type="list"
                    >
                        {children}
                    </StyledTypography>
                    {icon && (
                        <motion.span variants={{ hover: { x: "0.25rem" } }}>
                            <Icon name={icon} size="18" />
                        </motion.span>
                    )}
                </StyledButton>
            </motion.div>
        );
    }
}

const StyledButton = styled(Button)``;

export const ListButton = styled(ListButtonComponent)`
    position: relative;
    width: 100%;
    height: 2.5rem;
    border-radius: 0.1875rem;
    background-color: ${primary.steel02};
    display: flex;
    padding-left: 0.625rem;
    align-items: center;
    text-align: center;
    margin-bottom: 0.125rem;
    color: ${primary.white};

    ${(props: IListButtonProps) =>
        props.empty === true &&
        css`
            background-color: ${primary.steel01};
            margin-bottom: 0px;
            color: ${primary.silver};
            z-index: 0;
        `}

    svg {
        margin-right: 0.4875rem;
        fill: ${primary.white};
    }
`;

const Kebab = styled(CircleButton)`
    &&& {
        padding-top: 0rem;
        background-color: transparent;
        &:hover {
            background: ${primary.steel01};
        }

        svg {
            margin-top: 0.1875rem;
            margin-right: 0rem;
        }
    }
`;

const StyledTypography = styled(Typography)`
    width: 17.25rem;
    text-align: left;
    padding-left: 0.4875rem;
`;
